import { render } from "./RiskFixture.vue?vue&type=template&id=28c86d95"
import script from "./RiskFixture.vue?vue&type=script&lang=js"
export * from "./RiskFixture.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__